import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'content'];

  connect() {
    this.triggerTarget.addEventListener('click', (e) => {
      e.preventDefault();

      const expanded = this.element.classList.contains('expanded');

      if (expanded) {
        this.collapse();
      } else {
        this.expand();
      }
    });

    if (this.isExpanded()) {
      this.expand();
    }
  }

  isExpanded() {
    return this.element.classList.contains('expanded');
  }

  expand() {
    this.element.classList.add('expanded');
    this.contentTarget.style.height = this.contentTarget.scrollHeight + 'px';
  }

  collapse() {
    this.element.classList.remove('expanded');
    this.contentTarget.style.height = '0';
  }
}
